import { createGlobalStyle } from 'styled-components';

import { watermarkPattern } from 'assets/images';
import { TABLE_WATERMARK_ENABLED } from 'constants/tableWatermark';
import { mobileLargeMin } from './variables/mediaQueries';

export const TABLE_WATERMARK_ATTR = 'data-table-watermark';
export const TABLE_WATERMARK_LAYER_ATTR = 'data-table-watermark-layer';
export const TABLE_WATERMARK_LOGO_ATTR = 'data-table-watermark-logo';
export const TABLE_WATERMARK_OFFSET_ATTR = 'data-table-watermark-offset-top';

export const TABLE_WATERMARK_IMAGE = watermarkPattern;
export const TABLE_WATERMARK_LOGO_WIDTH = 44;
export const TABLE_WATERMARK_LOGO_HEIGHT = 18;
export const TABLE_WATERMARK_ROW_STEP = 2;
export const TABLE_WATERMARK_MOBILE_MEDIA = `(max-width: ${mobileLargeMin -
  1}px)`;

const WATERMARK_LAYER_OFFSET_TOP = 8;
export const TABLE_WATERMARK_DEFAULT_LEFT = '50%';

export const getWatermarkLayerLayoutStyle = (
  offsetTop = WATERMARK_LAYER_OFFSET_TOP
) => ({
  position: 'absolute',
  inset: `${offsetTop}px 0 0 0`,
  zIndex: '1',
  pointerEvents: 'none',
});

export const getWatermarkLogoStyle = ({ top, left }) => ({
  position: 'absolute',
  top: `${top}px`,
  left,
  width: `${TABLE_WATERMARK_LOGO_WIDTH}px`,
  height: `${TABLE_WATERMARK_LOGO_HEIGHT}px`,
  transform: 'translate(-50%, -50%)',
  opacity: '1',
  visibility: 'visible',
  display: 'block',
  filter: 'none',
  pointerEvents: 'none',
  userSelect: 'none',
});

export const TableWatermarkGlobalStyles = TABLE_WATERMARK_ENABLED
  ? createGlobalStyle`
      [${TABLE_WATERMARK_ATTR}] {
        position: relative;
        isolation: isolate;
      }
    `
  : () => null;
